export default "__VITE_ASSET__BkiKaqBZ__"